import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Brain } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const LIGHT_PATHS = ['/', '/login', '/register', '/blog', '/testler', '/bilimsel-dayanak', '/hakkimizda', '/iletisim'];

const Footer = () => {
  const location = useLocation();
  const { user } = useAuth();
  const isLight = !user && (LIGHT_PATHS.some(p => p === location.pathname) || location.pathname.startsWith('/blog') || location.pathname.startsWith('/testler') || location.pathname.startsWith('/bilimsel') || location.pathname.startsWith('/hakkimizda') || location.pathname.startsWith('/iletisim'));

  if (isLight) {
    return (
      <footer style={{ background: '#1A2B3C', borderTop: '1px solid rgba(255,255,255,0.06)' }} data-testid="footer">
        <div className="max-w-5xl mx-auto px-6 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <div className="flex items-center gap-2.5">
                <img src="/logo/icon-dark.svg" alt="" style={{ height: 24, width: 24 }} />
                <span style={{ fontSize: 17, fontWeight: 700, color: 'rgba(246,247,248,0.9)' }}>Doktor<span style={{ color: '#D9A258' }}>Cebinde</span></span>
              </div>
              <p style={{ fontSize: 14, color: 'rgba(246,247,248,0.4)', marginTop: 8, lineHeight: 1.6 }}>Kişisel sağlık takibi ve açıklayıcı değerlendirme deneyimi.</p>
            </div>
            <div>
              <h3 style={{ fontSize: 13, fontWeight: 600, color: 'rgba(246,247,248,0.55)', marginBottom: 14, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Platform</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/hakkimizda" style={{ color: 'rgba(246,247,248,0.4)', textDecoration: 'none', transition: 'color 0.2s' }}>Hakkımızda</Link></li>
                <li><Link to="/bilimsel-dayanak" style={{ color: 'rgba(246,247,248,0.4)', textDecoration: 'none' }}>Bilimsel Dayanak</Link></li>
                <li><Link to="/iletisim" style={{ color: 'rgba(246,247,248,0.4)', textDecoration: 'none' }}>İletişim</Link></li>
              </ul>
            </div>
            <div>
              <h3 style={{ fontSize: 13, fontWeight: 600, color: 'rgba(246,247,248,0.55)', marginBottom: 14, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Yasal</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/privacy" style={{ color: 'rgba(246,247,248,0.4)', textDecoration: 'none' }}>Gizlilik Politikası</Link></li>
                <li><Link to="/terms" style={{ color: 'rgba(246,247,248,0.4)', textDecoration: 'none' }}>Kullanım Şartları</Link></li>
              </ul>
            </div>
          </div>
          <div className="mt-10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-2" style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
            <p style={{ fontSize: 12, color: 'rgba(246,247,248,0.25)' }}>&copy; 2026 DoktorCebinde. Tüm hakları saklıdır.</p>
            <p style={{ fontSize: 12, color: 'rgba(246,247,248,0.25)' }}>Bu platform tıbbi tanı koymaz. Klinik değerlendirme yerine geçmez.</p>
          </div>
        </div>
      </footer>
    );
  }

  /* ─── DARK GLASS FOOTER (Authenticated pages) ─── */
  return (
    <footer style={{
      background: 'rgba(8, 14, 30, 0.78)',
      borderTop: '1px solid rgba(120, 150, 220, 0.10)',
    }} data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-3">
              <img src="/logo/icon-dark.svg" alt="" style={{ height: 24, width: 24 }} />
              <span className="text-lg font-semibold" style={{ color: 'rgba(255,255,255,0.88)' }}>Doktor<span style={{ color: '#D9A258' }}>Cebinde</span></span>
            </div>
            <p className="text-sm leading-relaxed" style={{ color: 'rgba(210,220,240,0.58)' }}>
              Kişisel sağlık takip ve destek platformu.
            </p>
          </div>
          <div>
            <h3 className="font-medium mb-4" style={{ color: 'rgba(255,255,255,0.75)' }}>Hakkında</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="transition-colors hover:text-cyan-400" style={{ color: 'rgba(210,220,240,0.55)' }}>Nasıl Çalışır</Link></li>
              <li><Link to="/privacy" className="transition-colors hover:text-cyan-400" style={{ color: 'rgba(210,220,240,0.55)' }}>Gizlilik Politikası</Link></li>
              <li><Link to="/terms" className="transition-colors hover:text-cyan-400" style={{ color: 'rgba(210,220,240,0.55)' }}>Kullanım Şartları</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="font-medium mb-4" style={{ color: 'rgba(255,255,255,0.75)' }}>Yardım</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/help" className="transition-colors hover:text-cyan-400" style={{ color: 'rgba(210,220,240,0.55)' }}>Yardım Merkezi</Link></li>
              <li><Link to="/disclaimer" className="transition-colors hover:text-cyan-400" style={{ color: 'rgba(210,220,240,0.55)' }}>Sorumluluk</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-6 flex flex-col sm:flex-row justify-between items-center gap-2 text-sm" style={{
          borderTop: '1px solid rgba(120,150,220,0.08)',
          color: 'rgba(180,195,220,0.4)',
        }}>
          <p>&copy; 2026 Doktor Cebinde. Tüm hakları saklıdır.</p>
          <p>Bu platform bir dijital sağlık asistanıdır ve tıbbi teşhis koymaz.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
